import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webimports-dev/htdocs/web-imports/src/app/servicos/manutencao-videogames/ManutencaoVideogamesPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webimports-dev/htdocs/web-imports/src/components/ui/ServicePageWrapper.tsx");
